<template>
  <div class="install_esim">
    <header-component
      :is-soon="true"
      :backRoute="false"
      img-left="/trocachip/img/default_white.png"
      img-right="/trocachip/img/access-white.svg"
      class="header-component"
    />

    <section class="installation_esim_section">
      <div class="activate_icon-success">
        <img src="../assets/images/ic-check.svg" v-if="!ac" />
        <img src="../assets/images/ic-check-ac.svg" v-if="ac" />
      </div>

      <h2
        class="activate_title"
        :class="{ 'ac-color-yellow': ac }"
        v-html="installPageMessages.title"
      ></h2>
      <p class="activate_info" v-html="installPageMessages.info"></p>
      <p class="activate_subinfo" v-html="installPageMessages.subinfo"></p>
      <span id="protocol" class="activate_protocol">
        {{ installPageMessages.protocolLabel }} {{ protocol }}
      </span>
    </section>
    <section class="installation_esim_section">
      <img src="img/validation-carousel/passo1de4.svg" />
      <p class="activate_info" v-html="installPageMessages.stepOneTitle"></p>
      <hr class="section_separator_line" />
    </section>

    <section class="installation_esim_section">
      <img src="img/validation-carousel/passo2de4.svg" />

      <p class="activate_info" v-html="installPageMessages.stepTwoTitle"></p>
      <section
        class="device_selection_container"
        v-if="selectedTab === 'manual'"
      >
        <div class="selection_container">
          <div class="selection_input" @click="toggleSystemSelectionOpened">
            <span
              v-html="
                systemSelected
                  ? systemSelected
                  : 'Selecione o sistema do seu aparelho'
              "
            />
          </div>
          <div
            class="selection_options_container"
            :class="{ opened_options: systemSelectionOpened }"
          >
            <label
              id="device_mark"
              v-for="(item, index) in systemsListToActive"
              :key="index"
              v-html="item"
              :value="item"
              @click="() => selectSystem(item)"
            />
          </div>
        </div>
      </section>

      <vue-qrcode
        :margin="2"
        :value="urlEsim"
        class="esim_qr_code"
        v-if="selectedTab === 'qrcode'"
      />

      <hr class="section_separator_line" />
    </section>

    <section class="installation_esim_section">
      <img src="img/validation-carousel/passo3de4.svg" />
      <p class="activate_info" v-html="installPageMessages.stepThreeTitle"></p>
      <p
        class="activate_info"
        v-html="installPageMessages.stepThreeSubTitle"
      ></p>
      <p class="activate_info" v-html="installPageMessages.stepThreeCopy"></p>
      <vue-qrcode :margin="2" :value="urlEsim" class="esim_qr_code" />
      <section
        class="esim_url_section"
        v-if="
          systemSelected == systemsListToActive.iosSystem &&
          selectedTab === 'manual'
        "
      >
        <div class="esim_url_container">
          <span class="esim_url" v-html="correctValue(2)"></span>
          <button
            class="copy_button"
            v-clipboard:copy="correctValue(2)"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>
      </section>

      <section
        class="esim_url_section"
        v-if="
          (systemSelected == systemsListToActive.samsungSystem ||
            systemSelected == systemsListToActive.motorolaSystem) &&
          selectedTab === 'manual'
        "
      >
        <div class="esim_url_container">
          <span class="esim_url" v-html="urlEsim"></span>
          <button
            class="copy_button"
            v-clipboard:copy="urlEsim"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>
      </section>
      <p
        class="activate_info"
        v-if="
          systemSelected == systemsListToActive.iosSystem &&
          selectedTab === 'manual'
        "
      >
        Endereço SM-DP+
      </p>
      <section
        class="esim_url_section"
        v-if="
          systemSelected == systemsListToActive.iosSystem &&
          selectedTab === 'manual'
        "
      >
        <div class="esim_url_container">
          <span class="esim_url" v-html="correctValue(1)"></span>
          <button
            class="copy_button"
            v-clipboard:copy="correctValue(1)"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            @click="() => onCopy()"
          >
            <img src="../assets/images/copy-icon.svg" />
          </button>
        </div>
      </section>

      <hr class="section_separator_line" />
    </section>

    <section class="installation_esim_section" v-if="selectedTab === 'manual'">
      <img src="img/validation-carousel/passo4de4.svg" />
      <p class="activate_info" v-html="installPageMessages.stepFourTitle"></p>
      <hr class="section_separator_line" />
    </section>

    <button
      class="instalation_instructions_button"
      @click="goToInstallationGuide"
    >
      {{ installPageMessages.buttonText }}
    </button>
    <toast v-if="toast.open" @closetoast="closeToast"></toast>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderComponent from "../components/HeaderComponent.vue";
import Toast from "../components/Toast.vue";
import trackEvent from "../services/trackEvent";
import VueQrcode from "vue-qrcode";

export default {
  name: "install_esim_old",
  components: {
    HeaderComponent,
    Toast,
    VueQrcode,
  },
  data() {
    return {
      systemSelected: "Samsung Android 10.0 ou superior",
      systemSelectionOpened: false,
      systemsListToActive: "",
      selectedTab: "manual",
      toast: {
        open: false,
      },
    };
  },
  created() {
    this.sendTracker("troca esim", 7, 3);
    this.systemsListToActive = this.systemsToActive;
  },
  computed: {
    ...mapState({
      config: (state) => state.config,
      ac: (state) => state.ac,
      installPageMessages: (state) => state.config.installEsimPageMessages,
      protocol: (state) => state.protocol,
      urlEsim: (state) => state.urlEsim,
      customer: (state) => state.customer,
      systemsToActive: (state) => state.config.systemsToActive,
      iccid: (state) => state.iccidEsim,
    }),
  },
methods: {
    handleTabChange(tab) {
      this.selectedTab = tab;
    },
    onCopy() {
      if (this.toast) {
        this.toast.open = true;
        console.log("Código copiado com sucesso!");
      } else {
        console.error("O componente Toast não foi encontrado.");
      }
    },
    closeToast() {
      this.toast.open = false;
    },
    onError() {
      console.log("Erro ao copiar código");
    },
    goToInstallationGuide() {
      this.sendTracker("como instalar");
      this.$router.push({ name: "installation-guide" });
    },
    sendTracker(eventLabel, eventCategory = 6, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": eventCategory,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.isExOi() ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    isExOi() {
			if (this.config['init_flow'] === undefined) {
				this.alertError = true;
			}

			return JSON.parse(this.customer.isExOiCustomer);
		},
    selectSystem(value) {
      this.systemSelected = value;
      this.systemSelectionOpened = false;
    },
    toggleSystemSelectionOpened() {
      this.systemSelectionOpened = !this.systemSelectionOpened;
    },
    correctInfo(field) {
      if (this.systemSelected == this.systemsToActive.iosSystem && field == 1) {
        return "Endereço SM-DP+";
      } else if (
        this.systemSelected == this.systemsToActive.iosSystem &&
        field == 2
      ) {
        return "Código de ativação";
      } else return "Código de ativação";
    },
    correctValue(value) {
      const str = this.urlEsim;
      const urlEsim = str.split("$");
      return urlEsim[value];
    },
  },
};
</script>

<style lang="scss" scoped>
.install_esim {
  width: 100%;
  height: 100vh;
  display: block;
  position: fixed;
  background: #003091;
  overflow-y: auto;
  z-index: -1;
  > .installation_esim_section {
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    > .device_selection_container {
      margin-top: 2.125rem;
      display: flex;
      flex-direction: column;
      width: 85vw;
      > .selection_container {
        position: relative;
        > .selection_input {
          width: 100%;
          height: 52px;
          padding: 0px 24px;
          border-radius: 26px;
          color: #000;
          margin-bottom: 1.5rem;
          font-family: "timsans_regular";
          font-size: 1rem;
          -webkit-appearance: none;
          -moz-appearance: none;
          overflow: auto;
          border: 1px solid #b3b3b3;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          cursor: pointer;
          background-color: #ffffff;
        }
        > .selection_options_container {
          display: none;
        }
        > .selection_options_container.opened_options {
          position: absolute;
          display: flex;
          width: 100%;
          max-height: 200px;
          overflow-y: scroll;
          overflow-x: hidden;
          flex-direction: column;
          background: #fff;
          border-radius: 16px;
          box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.15);
          z-index: 10;
          > label {
            width: 100%;
            padding: 24px 0 0 24px;
            font-family: "timsans_regular";
            font-size: 0.875rem;
            color: #9c9c9c;
            line-height: 21px;
            cursor: pointer;
          }
          > label:last-child {
            padding-bottom: 24px;
          }
          > label:hover {
            background-color: #e7e7e7;
          }
        }
        > .selection_input::-ms-expand {
          display: none;
        }
        > .selection_input::after {
          content: "<";
          font: 20px "Consolas", monospace;
          color: #9c9c9c;
          -webkit-transform: rotate(180deg) scaleY(1.2);
          -moz-transform: rotate(270deg) scaleY(1.2);
          -ms-transform: rotate(270deg) scaleY(1.2);
          transform: rotate(270deg) scaleY(1.2);
          right: 40px;
          position: absolute;
          pointer-events: none;
        }
      }
    }
    > .activate_icon-success {
      width: 61px;
      height: 61px;
      margin: 63px auto 0 auto;
      position: relative;
      display: block;
    }
    > .activate_title {
      width: 292px;
      height: auto;
      display: block;
      position: relative;
      font-family: "timsans_regular";
      margin: 40px auto 0 auto;
      font-size: 1.688em;
      font-weight: 300;
      line-height: 1.11;
      text-align: center;
      color: #ffffff;
    }
    > .activate_info {
      width: 85vw;
      height: auto;
      display: block;
      position: relative;
      margin: 16px auto 0 auto;
      font-family: "timsans_regular";
      font-size: 14px;
      line-height: 1.33;
      letter-spacing: -0.3px;
      text-align: center;
      color: #ffffff;
    }
    > .activate_info_values {
      width: 85vw;
      height: auto;
      display: block;
      position: relative;
      margin: 16px auto 0 auto;
      font-family: "timsans_regular";
      font-size: 1em;
      line-height: 1.33;
      letter-spacing: -0.3px;
      color: #ffffff;
    }
    > .activate_subinfo {
      width: 85vw;
      height: auto;
      display: block;
      position: relative;
      margin: 16px auto 0 auto;
      font-family: "timsans_regular";
      font-size: 0.75em;
      line-height: 1.33;
      letter-spacing: -0.3px;
      text-align: center;
      color: #ffffff;
    }
    > .activate_protocol {
      width: 147px;
      height: auto;
      display: block;
      position: relative;
      margin: 16px auto 40px auto;
      font-family: "timsans_regular";
      font-size: 0.75em;
      line-height: 2;
      text-align: center;
      color: #ffffff;
    }
    > .section_separator_line {
      width: 85vw;
      height: 1px;
      background-color: #d9d9d9;
      margin: 26px 0 32px 0;
      border: none;
      opacity: 0.5;
    }
    > .esim_qr_code {
      border-radius: 8px;
      margin-top: 22px;
    }
    > .esim_url_section {
      margin-top: 24px;

      border: 1px dashed #bababa;
      border-radius: 12px;
      background-color: #fff;
      width: 85%;
      height: 56px;

      > .esim_url_container {
        padding-left: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 8px;
        > .esim_url {
          white-space: nowrap;
          word-wrap: break-word;
          text-overflow: ellipsis;
          overflow: hidden;
          font-family: "timsans_regular";
          color: #000;
          padding-right: 5px;
        }
        > .copy_button {
          height: 50px;
          background: transparent;
          cursor: pointer;
          padding: 0px 14px;
          border-left: 1px dashed #bababa;
          border-right: none;
        }
      }
    }
  }

  > .instalation_instructions_button {
    width: 85vw;
    height: 52px;
    border: 1px solid #fff;
    border-radius: 26px;
    color: #fff;
    background-color: transparent;
    margin: 26px;
    font-family: "timsans_regular";
  }
}
</style>
